import { CaseStudies } from 'almanac-ui/icons/blaze/32'
import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { avoid } from './shared/avoid'
import { seoWords } from './shared/seoWords'
import { brandVoiceId, tone } from './shared/voiceTones'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { productName } from './shared/productName'
import { safify } from './utils/safify'
import { additionalInfo } from './shared/additionalInfo'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  icon: CaseStudies,
  steps: ['Context', 'Generate Case Study'],
  title: TextChannels[ChannelType.CaseStudy].name,
  submitLabel: 'Generate Case Study',
  type: ChannelType.CaseStudy,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183781/Home%20Card%20Previews/g4w6aqz66xfviys5bqkr.png',
}

const fields = {
  product_name: productName.required().meta({
    label: 'What is your product or company name?',
    placeholder: 'What is the name of the product/company you are promoting?',
  }),
  case_study_customer_name: string()
    .required()
    .default('')
    .meta({
      label: 'Customer featured in the case study',
      placeholder: 'What is the name of the customer to be highlighted?',
      rows: 3,
      snippets: true,
    })
    .transform(safify),
  case_study_challenges: string()
    .required()
    .default('')
    .meta({
      label: 'Initial challenges experienced by the customer',
      placeholder: "Add 2-3 sentences to summarize your customer's experience",
      rows: 3,
      snippets: true,
    })
    .transform(safify),
  case_study_solutions: string()
    .required()
    .default('')
    .meta({
      label: 'How did your company solve these challenges?',
      placeholder: 'Add 2-3 sentences to summarize',
      rows: 3,
      snippets: true,
    })
    .transform(safify),
  case_study_outcomes: string()
    .required()
    .default('')
    .meta({
      label: 'What outcomes did the customer achieve?',
      placeholder: 'What was the result? You can include specific data points',
      rows: 3,
      snippets: true,
    })
    .transform(safify),
  additional_info: additionalInfo.meta({
    label: 'What facts, notes, or quotes do you want to include?',
    rows: 3,
    collapsible: true,
    snippets: true,
  }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  tone,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  language,
  seo_words: seoWords.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const CaseStudySchema = object(fields).meta(meta) as FormSchema<ChannelType>

export const CaseStudyMultiStepSchema: MultiStepSchema<ChannelType.CaseStudy> = {
  steps: [
    CaseStudySchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: ChannelType.CaseStudy }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.CaseStudy,
    channel: ChannelType.CaseStudy,
  },
}
